const state = {
  plaincustomers: [],
  customers: [],
  customer: {}
};

export default {
  namespaced: true,
  state,
  mutations: {
    setCustomers(state, customers) {
      state.customers = customers;
    },
    setCustomer(state, customer) {
      state.customer = customer;
    },
    setPlainCustomers(state, plaincustomers) {
      state.plaincustomers = plaincustomers;
    }
  },
  actions: {
    fetchCustomers({ commit }, payload) {
      const { dontPaginate, filter, page, paginationcount } = payload;
      if (!!dontPaginate || typeof dontPaginate === 'undefined') {
        commit('SET_LOADING', true, { root: true });
        if (!!filter || typeof filter === 'undefined') {
          return axios
            .get('api/v1/customer', {
              params: { page: payload.page, filter: filter, paginationcount: paginationcount }
            })
            .then(response => {
              commit('setCustomers', response.data);
            })
            .catch(error => {
              if (error.response.status == 403) {
                commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              }
            })
            .finally(() => {
              commit('SET_LOADING', false, { root: true });
            });
        }
        return axios
          .get('api/v1/customer', {
            params: { page: payload.page, paginationcount: paginationcount }
          })
          .then(response => {
            commit('setCustomers', response.data);
          })
          .catch(error => {
            if (error.response.status == 403) {
              commit(
                'SET_SNACK_BAR',
                {
                  message: error.response.data['message'],
                  color: 'error'
                },
                { root: true }
              );
            }
          })
          .finally(() => {
            commit('SET_LOADING', false, { root: true });
          });
      } else {
        if (!!filter || typeof filter === 'undefined') {
          return axios
            .get('api/v1/customer', { params: { paginate: 0, filter: filter } })
            .then(response => {
              commit('setPlainCustomers', response.data);
            })
            .finally(() => commit('SET_LOADING', false, { root: true }));
        }
        return axios.get('api/v1/customer', { params: { paginate: 0 } }).then(response => {
          commit('setPlainCustomers', response.data);
        });
      }
    },
    getCustomer({ commit }, payload) {
      return axios
        .get(`api/v1/customer/${payload.id}`)
        .then(response => {
          commit('setCustomer', response.data);
        })
        .catch(error => {
          if (error.response.status == 403) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
            commit('setCustomer', {});
          }
        })
        .catch(error => {
          if (error.response.status == 404) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
            commit('setCustomer', {});
          }
        });
    }
  }
};
